import { clomp } from 'clomp';

export const Base = clomp.div`
  bg-white
  shadow-[0px_2px_8px_0px_#E9E9E9]
  cursor-pointer
  duration-500
  flex
  flex-col
  h-full
  px-6
  py-4
  rounded-lg
  transition-all
  w-full
`;
